
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRain as ObiRainElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-rain.js';
 
 
 

 
 export const ObiRain = createComponent({
   react: React,
   tagName: 'obi-rain',
   elementClass: ObiRainElement,
   events: {
     
   }
  });
 
 